import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

// Run before React renders: reserve the native status bar outside the WKWebView,
// rather than guessing its height in CSS. Browser and Android are untouched.
export async function initializeNativeIosShell() {
  if (Capacitor.getPlatform() !== 'ios') return;
  if (!Capacitor.isPluginAvailable('StatusBar') || !Capacitor.isPluginAvailable('Keyboard')) {
    throw new Error('I plugin della schermata iOS non sono disponibili. È necessario aggiornare la versione nativa dell’app.');
  }
  await StatusBar.setOverlaysWebView({ overlay: false });
  await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
  document.documentElement.dataset.nativePlatform = 'ios';
  await Keyboard.addListener('keyboardWillShow', () => {
    document.documentElement.dataset.nativeKeyboard = 'open';
  });
  await Keyboard.addListener('keyboardDidHide', () => {
    delete document.documentElement.dataset.nativeKeyboard;
  });
}
